import yup from '@/plugins/yup'

const aggregationValues = ['mean', 'median', 'last', 'sum', 'max', 'min'] as const

const sourceTypeField = yup
  .string()
  .oneOf(['sensor', 'group'])
  .default('sensor')
  .required()

const sensorOrGroupFields = {
  sourceType: sourceTypeField,
  sensorId: yup.string().when('sourceType', {
    is: 'group',
    then: (schema) => schema.optional().nullable(),
    otherwise: (schema) => schema.required('Selecione um sensor'),
  }),
  groupId: yup.string().when('sourceType', {
    is: 'group',
    then: (schema) => schema.required('Selecione um grupo'),
    otherwise: (schema) => schema.optional().nullable(),
  }),
}

const aggregationField = yup.string().when('sourceType', {
  is: 'group',
  then: (schema) => schema.optional().nullable(),
  otherwise: (schema) =>
    schema.oneOf([...aggregationValues]).required('Selecione a agregação'),
})

// Base schema for sensor-only widgets - title and sensor are required
export const baseWidgetSchema = yup.object({
  title: yup.string().required('O título é obrigatório'),
  sensorId: yup.string().required('Selecione um sensor'),
})

// Indicator widget: sensor ou grupo + campo de dados
export const indicatorWidgetSchema = yup.object({
  title: yup.string().required('O título é obrigatório'),
  ...sensorOrGroupFields,
  dataField: yup.string().required('Selecione o campo de dados'),
  aggregation: aggregationField,
})

// Gauge widget: sensor ou grupo + config do gauge
export const gaugeWidgetSchema = yup.object({
  title: yup.string().required('O título é obrigatório'),
  ...sensorOrGroupFields,
  dataField: yup.string().required('Selecione o campo de dados'),
  min: yup.number().required('O valor mínimo é obrigatório'),
  max: yup.number().required('O valor máximo é obrigatório'),
  threshold: yup.number().required('O limiar é obrigatório'),
})

export const dataFieldWidgetSchema = baseWidgetSchema.concat(
  yup.object({
    dataField: yup.string().required('Selecione o campo de dados'),
  }),
)

// Widgets with aggregation and data field (bar-chart)
export const aggregationWidgetSchema = dataFieldWidgetSchema

// Pie / bar: sensor ou grupo + múltiplos campos
export const pieChartWidgetSchema = yup.object({
  title: yup.string().required('O título é obrigatório'),
  ...sensorOrGroupFields,
  dataFields: yup
    .array()
    .of(yup.string())
    .min(1, 'Selecione ao menos um campo de dados')
    .required(),
  aggregation: aggregationField,
})

export const barChartWidgetSchema = pieChartWidgetSchema

// Time series: title + sensor; sensor correlacionado opcional (eixo Y duplo)
export const timeSeriesWidgetSchema = baseWidgetSchema.concat(
  yup.object({
    secondarySensorId: yup.string().optional().nullable(),
  }),
)
export const statusPanelWidgetSchema = baseWidgetSchema

export const openAlarmsWidgetSchema = yup.object({
  title: yup.string().required('O título é obrigatório'),
})

// Totalizers widget: title, sensor and specific data_field (demand, utilization, consumption, mixingCycle)
export const totalizersWidgetSchema = yup.object({
  title: yup.string().required('O título é obrigatório'),
  sensorId: yup.string().required('Selecione um sensor'),
  dataField: yup
    .string()
    .required('Selecione o campo de dados')
    .oneOf(['demand', 'utilization', 'consumption', 'mixingCycle'], 'Campo de dados inválido'),
})
